import classnames from 'classnames'
import Heart from '../svg/heart'

export default function FavoriteToggle({
  isFavorite,
  isFavoriteProcessing,
  onClick,
  size,
  ...rest
}) {
  return (
    <button
      {...rest}
      aria-label='toggle favorite'
      className={classnames('favoriteToggle flatBtn', rest.className)}
      onClick={onClick}
      disabled={isFavoriteProcessing}
    >
      <Heart fill={isFavorite ? 'var(--alert-color)' : 'var(--secondary-input-bg)'} />

      <style jsx>{`
        .favoriteToggle {
          :global(svg) {
            width: 100%;
            height: auto;
          }
        }
      `}</style>

      <style jsx>{`
        .favoriteToggle {
          ${size === 'lg' ? 'width: 7rem; height: 6.5rem;' : 'width: 3.4rem; height: 3.2rem;'}
        }

        @media (max-width: 1024px) {
          .favoriteToggle {
            width: 2.8rem;
            height: 2.6rem;
          }
        }
      `}</style>
    </button>
  )
}
